/**
 * Shared page-shell layout for the reporting prototype's full pages (library,
 * builder, detail, dashboard): responsive horizontal padding, a capped width
 * and centered. Pages append their own vertical rhythm via `gap-*`.
 *
 * Centralized so width/padding tweaks land in one place rather than drifting
 * across four near-identical class strings.
 */
export const REPORTING_PAGE_SHELL =
  'px-6 py-6 lg:px-12 xl:px-20 2xl:px-28 flex flex-col w-full max-w-screen-2xl mx-auto'
